import * as React from "react";
import { ClientConfig } from "gen/clients";
import { LanguageGroupsTable } from "./LanguageGroupsTable";
import { useClientReadOnly } from "contexts/ClientLockContext";

interface Props {
  clientConfig: ClientConfig;
  onSaveSuccess: () => void;
}

const LanguageGroupsTab: React.FC<Props> = ({ clientConfig, onSaveSuccess }) => {
  const isReadOnly = useClientReadOnly();
  return <LanguageGroupsTable clientConfig={clientConfig} viewOnly={isReadOnly} onChange={onSaveSuccess} />;
};

export { LanguageGroupsTab };
